export default __webpack_public_path__ + "static/media/0xe6fc6c7cb6d2c31b359a49a33ef08ab87f4de7ce.48b731f7.webp";